// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import SelectListDialog2 from './SelectListDialog2';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import GroupIcon from '@mui/icons-material/Group';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';

import { AgGridColumn, AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-community/styles/ag-theme-material.css';




export default function DocDListGridEdit(props) {

  const { onActionChange, onSelectChange } = props;

  const gridData = props.gridData || [];



  const onSelectionChanged = (params) => {
    // console.log('Selection Changed', params);
    let nodes = params.api.getSelectedNodes();
    // console.log('Selected nodes', nodes);

    let selRecs = nodes.map(item => {
      return item.data
    });

    onSelectChange && onSelectChange(selRecs);

  }

  const handleActionChange = (aUserID, aNewValue) => {
    // console.log("handleActionChange", aUserID, aNewValue);

    const vChangeData = gridData.find(d => d.ToUserID == aUserID && d.ActionReq != aNewValue);

    if (vChangeData) {
      // console.log("handleActionChange vChangeData", vChangeData);
      onActionChange && onActionChange(vChangeData, aNewValue);
    }


  };


  const [editingID, setEditingID] = useState("");
  const [editingActionReq, setEditingActionReq] = useState(0);

  const handleActionBtnClick = (aUserID, aActionReq) => {
    // console.log("handleActionBtnClick", aIdx, aActionReq);

    setEditingID(aUserID);
    setEditingActionReq(aActionReq);
    setOpenSelectActionDialog(true);
  }




  const actionOptions = Object.entries(DmsCommon.ActionListEnum).map(([key, value]) => {
    return {
      "name": DmsCommon.ActionEnumToStr(value),
      "value": value,
    }
  })

  const [openSelectActionDialog, setOpenSelectActionDialog] = useState(false);

  const handleSelectedAction = (aValues) => {
    // console.log("handleSelectedAction", aValues);

    setOpenSelectActionDialog(false);
    handleActionChange(editingID, aValues);
  }


  const ActionCellRenderer = (params) => {
    // console.log("actionCellRenderer", params);

    const vUserID = params.data.ToUserID;
    const vActionReq = params.value;
    const vAction = DmsCommon.ActionEnumToStr(vActionReq);

    return (
      <Box component="div" sx={{ p: 0, flexGlow: 1 }}>
        <Button
          color="primary"
          size="small"
          startIcon={<EditIcon />}
          onClick={() => handleActionBtnClick(vUserID, vActionReq)}
          fullWidth
          disableRipple >
          {vAction}
        </Button>
      </Box>

    );
  };

  const cellStyle = { paddingLeft: '10px', paddingRight: '10px', fontSize: '0.8rem' };

  const compareStrInsensitive = (aStrA, aStrB) => {
    return aStrA.localeCompare(aStrB, undefined, { sensitivity: "base" })
  }

  const comparatorUserName = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.ToUserName, nodeB.data.ToUserName)
  }

  const comparatorDept = (a, b, nodeA, nodeB) => {
    return compareStrInsensitive(nodeA.data.DeptName, nodeB.data.DeptName)
  }

  const UserTypeRenderer = (params) => {
    return (

      <IconButton color="primary" aria-label="upload picture" component="span">
        {params.value === true && <AccountCircleIcon />}
        {params.value !== true && <GroupIcon />}
      </IconButton>
    )
  }

  const columnDefs = useMemo(() => [
    { field: 'IsUser', headerName: " ", cellStyle: cellStyle, width: 50, cellRenderer: UserTypeRenderer, },
    {
      field: 'ToUserName', headerName: "Username", cellStyle: cellStyle, minWidth: 150, sort: "asc",
      flex: "1", headerCheckboxSelection: true, checkboxSelection: true, comparator: comparatorUserName
    },
    {
      field: 'DeptName', headerName: "Dept.", cellStyle: cellStyle, minWidth: 150, flex: "1",
      comparator: comparatorDept
    },
    { field: 'ActionReq', headerName: "Action", cellStyle: cellStyle, minWidth: 200, cellRenderer: ActionCellRenderer },
  ], []);




  return (
    <React.Fragment>

      <SelectListDialog2
        open={openSelectActionDialog}
        selectLabel="Action"
        iniValue={editingActionReq}
        options={actionOptions}
        onSelected={handleSelectedAction}
        onClose={() => setOpenSelectActionDialog(false)}
      />

      <div className="ag-theme-material" style={{ width: '100%', height: '100%', bgcolor: 'yellow' }}>
        <AgGridReact

          rowData={gridData}

          defaultColDef={{
            width: 100,
            resizable: true,
            sortable: true,
            suppressMovable: true,
          }}
          columnDefs={columnDefs}
          headerHeight={40}

          suppressNoRowsOverlay

          rowSelection="multiple"
          rowMultiSelectWithClick
          suppressRowClickSelection
          onSelectionChanged={onSelectionChanged}

        // onGridReady={onGridReady}
        // onCellClicked={onCellClicked}
        >



        </AgGridReact>

      </div>

    </React.Fragment>

  );
}

DocDListGridEdit.propTypes = {
  gridData: PropTypes.array,
  onActionChange: PropTypes.func,
  onSelectChange: PropTypes.func,
};
